/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReconciliationInputs */

const en_nav_reconciliation = /** @type {(inputs: Nav_ReconciliationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconciliation with BC`)
};

/**
* | output |
* | --- |
* | "Reconciliation with BC" |
*
* @param {Nav_ReconciliationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_reconciliation = /** @type {((inputs?: Nav_ReconciliationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReconciliationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_reconciliation(inputs)
});